<template>
  <div class="mine-head">
    <div class="role-info" v-if="infos">
      <div class="head-img">
        <img v-if="infos.img" :src="infos.img" alt="" />
        <img v-else :src="require('../../assets/images/home/unuser_head.svg')" alt=""/>
      </div>
      <div class="infos-btn" @click="$emit('open-role-detail')" v-if="role !== 3">
        编辑资料
      </div>
    </div>
    <div class="role-name">
      {{ infos.name || "佚名" }}
      <!-- <img v-if="infos.isVip" src="../../assets/images/mine/vip-sign.svg" alt=""/> -->
    </div>
    <!-- <div class="subjoin-infos">
      <div class="sub-item" v-for="(item, i) in infos.subjoin" :key="i">
        <p class="lab">{{ item.lab }}</p>
        <p class="val">{{ item.val }}</p>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  props: {
    infos: {
      type: Object,
      default: () => {
        return null;
      }
    }
  },
  computed: {
    role() {
      return this.$store.state.role;
    }
  }
};
</script>

<style lang="scss" scoped>
.mine-head {
  height: 192px;
  width: 100%;
  overflow: hidden;
  .role-info {
    margin-top: 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .head-img {
      padding-left: 20px;
      display: flex;
      align-items: center;
      img {
        width: 64px;
        height: 64px;
        border-radius: 32px;
      }
    }
    .infos-btn {
      width: 64px;
      height: 24px;
      background: linear-gradient(90deg, #5dd682 0%, #5aff8e 100%);
      opacity: 1;
      border-radius: 14px;
      font-size: 12px;
      color: #fff;
      text-align: center;
      line-height: 24px;
      margin-right: 32px;
      img {
        width: 14px;
        height: 14px;
      }
      span {
        font-size: 12px;
        color: #fff;
        margin-left: 3px;
      }
    }
  }
  .role-name {
    margin-top: 15px;
    margin-left: 20px;
    text-align: left;
    height: 25px;
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    opacity: 1;
    min-width: 64px;
    max-width: 5rem;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .subjoin-infos {
    margin-top: 36px;
    display: flex;
    padding: 0 20px;
    .sub-item {
      line-height: 20px;
      height: 20px;
      // min-width: 130px;
      margin-right: 20px;
      color: #999999;
      position: relative;
      display: flex;
      .val {
        color: #333333;
        font-weight: bold;
        font-size: 16px;
      }
      .lab {
        font-size: 14px;
        margin-right: 8px;
      }
    }
  }
}
</style>
